import styled from "@emotion/styled";

export const Details = styled("div")({
  marginBottom: 24,
  display: "flex",
  flexDirection: "column",
  gap: 24,
});
